/* eslint-disable no-case-declarations */
import * as types from './types';

const initialState = {
  items: [],
  searchedItems: [],
  groups: null,
  templates: [],
  notesLoading: true,
  error: null,
  templateSaved: false,
};

export default (state = initialState, action) => {
  const id = action?.payload?.id;
  const url = action?.payload?.url;
  const title = action?.payload?.title;
  const { note } = action.payload || {};
  const { notesTemplateList } = action.payload || [];
  const groupList = action.payload?.groupList || [];
  const groupId = action.payload?.groupId;
  const groupName = action.payload?.groupName;
  const groupExpand = action.payload?.groupExpand;
  const noteTemplate = action.payload?.noteTemplate;

  switch (action.type) {
    case types.GET_NOTES:
      return { ...state, notesLoading: action.payload.notesLoading };
    case types.GET_NOTES_SUCCESS:
      return {
        ...state,
        items: action.payload,
        notesLoading: false,
        error: null,
      };
    case types.GET_NOTES_FAIL:
      return { ...state, notesLoading: false };
    case types.SEARCH_NOTES:
      return { ...state };
    case types.SEARCH_NOTES_SUCCESS:
          return {
            ...state,
            searchedItems: action.payload,
          };
    case types.SEARCH_NOTES_FAIL:
      return { ...state };
    case types.GET_SINGLE_NOTE:
      return state;
    case types.GET_SINGLE_NOTE_SUCCESS:
      return state;
    case types.GET_SINGLE_NOTE_FAIL:
      return state;
    case types.UPDATE_INDEX_PREFERENCES:
      return state;
    case types.UPDATE_INDEX_PREFERENCES_SUCCESS:
      return state;
    case types.UPDATE_INDEX_PREFERENCES_FAIL:
      return state;
    case types.CREATE_NOTE_SUCCESS:
      return state;
    case types.UPDATE_NOTE:
      return state;
    case types.UPDATE_NOTE_SUCCESS:
      const noteId = note?.id;
      const updateNote = (notesItems, notesItem) => {
        if (notesItem.id === noteId) {
          const changedNote = { ...notesItem };
          return ([...notesItems, { ...changedNote, ...note }]);
        }
        return ([...notesItems, notesItem]);
      };
      return {
        ...state,
        items: state.items?.flat().reduce((notesItems, notesItem) => {
          return updateNote(notesItems, notesItem);
        }, []),
      };
    case types.UPDATE_NOTE_FAIL:
      return state;
    case types.DELETE_NOTE_SUCCESS:
      return { ...state, items: state.items?.filter((el) => el.id !== id) };
    case types.UPDATE_URL_SUCCESS:
      return {
        ...state,
        items: state.items?.map((el) => {
          if (el.id === id) {
            return { ...el, url };
          }
          return { ...el };
        }),
      };
    case types.RENAME_NOTE_SUCCESS:
      return {
        ...state,
        items: state.items?.map((el) => {
          if (el.id === id) {
            return { ...el, title };
          }
          return { ...el };
        }),
      };
    case types.GET_NOTE_GROUPS:
      return state;
    case types.GET_NOTE_GROUPS_SUCCESS:
      return { ...state, groups: groupList };
    case types.GET_NOTE_GROUPS_FAIL:
      return state;
    case types.RENAME_NOTE_GROUP:
      return state;
    case types.RENAME_NOTE_GROUP_SUCCESS:
      return {
        ...state,
        groups: state.groups?.map(el => {
          if (el.id === groupId) {
            return { ...el, name: groupName };
          }
          return { ...el };
        }),
      };
    case types.DELETE_NOTE_GROUP:
      return state;
    case types.DELETE_NOTE_GROUP_SUCCESS:
      return {
        ...state,
        groups: state.groups.filter((el) => el.id !== groupId),
        items: state.items.map((el) => {
          const index = action.payload.groupNotes.findIndex(n => n.id === el.id);
          if (index !== -1) {
            return { ...action.payload.groupNotes[index] };
          }
          return { ...el };
        }),
      };
    case types.REORDER_NOTES:
      return state;
    case types.REORDER_NOTES_SUCCESS:
      return { ...state, error: null };
    case types.REORDER_NOTES_FAIL:
      return { ...state, error: action.payload };
    case types.GET_TEMPLATES:
      return state;
    case types.GET_TEMPLATES_SUCCESS:
      return { ...state, templates: notesTemplateList };
    case types.GET_TEMPLATES_FAIL:
      return state;
    case types.REORDER_NOTE_TEMPLATES_SUCCESS:
      return { ...state, error: null };
    case types.REORDER_NOTE_TEMPLATES_FAIL:
      return { ...state, error: action.payload };
    case types.UPDATE_NOTE_TEMPLATE_SUCCESS:
      return  {
        ...state,
        templates: [...state.templates.map(t => {
          if (t.id === noteTemplate.id) return noteTemplate;
          return t;
        })],
      };
    case types.CREATE_NOTE_GROUP:
      return state;
    case types.CREATE_NOTE_GROUP_SUCCESS:
      const notes = [];
      action.payload.notesGroups?.forEach((g) => {
        g.notes?.forEach((n) => {
          notes.push(n);
        });
      });
      return {
        ...state,
        groups: action.payload.notesGroups.sort((a, b) => {
          if (a.order > b.order)
              return -1;
          if (a.order < b.order)
              return 1;
          return 0;
        }),
        items: state.items.map((el) => {
          const index = notes.findIndex(n => n.id === el.id);
          if (index !== -1) {
            return { ...el, groupId: notes[index].groupId };
          }
          return { ...el };
        }),
      };
    case types.UPDATE_NOTE_GROUP_VIEW:
      return state;
    case types.UPDATE_NOTE_GROUP_VIEW_SUCCESS:
      return {
        ...state,
        groups: state.groups?.map(el => {
          if (el.id === groupId) {
            return { ...el, expand: groupExpand };
          }
          return { ...el };
        }),
      };
    case types.UPDATE_NOTE_GROUP_VIEW_FAIL:
      return state;
    case types.CREATE_NOTE_COMMENT:
      return state;
    case types.CREATE_NOTE_COMMENT_SUCCESS:
      return {
        ...state,
        items: state.items.map(el => {
          if (el.id === Number(action.payload.noteId)) {
            return {
              ...el,
              comments: [...el.comments, action.payload.comment],
           };
          }
          return { ...el };
        }),
      };
    case types.CREATE_NOTE_COMMENT_FAIL:
      return state;
    case types.UPDATE_NOTE_COMMENT:
      return state;
    case types.UPDATE_NOTE_COMMENT_SUCCESS:
      return {
        ...state,
        items: state.items.map(el => {
          if (el.id === Number(action.payload.noteId)) {
            return {
              ...el,
              comments: [...el.comments.map(item => {
                if (item.id === Number(action.payload.comment.id)) {
                  return {
                    ...item,
                    body: action.payload.comment.body,
                    updatedAt: action.payload.comment.updatedAt,
                  };
                }
                return { ...item };
              })],
            };
          }
          return { ...el };
        }),
      };
    case types.UPDATE_NOTE_COMMENT_FAIL:
      return state;
    case types.DELETE_NOTE_COMMENT:
      return state;
    case types.DELETE_NOTE_COMMENT_SUCCESS:
      return {
        ...state,
        items: state.items.map(el => {
          if (el.id === Number(action.payload.noteId)) {
            return {
              ...el,
              comments: [...el.comments.filter(item => item.id !== Number(action.payload.id))],
            };
          }
          return { ...el };
        }),
      };
    case types.DELETE_NOTE_COMMENT_FAIL:
      return state;
    case types.SAVE_TEMPLATE:
      return { ...state, templateSaved: false };
    case types.SAVE_TEMPLATE_SUCCESS:
      return { ...state, templateSaved: true };
    case types.SAVE_TEMPLATE_FAIL:
      return { ...state, templateSaved: false };
    default:
      return state;
  }
};
